module.exports = __webpack_public_path__ + "img/logo.347bb159.jpg";